import { jsx } from "react/jsx-runtime";
import { MediaObject } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockMediaObject = ({
  attrs,
  index,
  innerBlocks
}) => {
  const mediaBlock = innerBlocks.find((block) => block.blockName === "constellation/media-object-media");
  const bodyBlock = innerBlocks.find((block) => block.blockName === "constellation/media-object-body");
  if (attrs && (typeof attrs.reverse === "undefined" || attrs.reverse === false)) {
    delete attrs.reverse;
  }
  return /* @__PURE__ */ jsx(MediaObject, { media: generateBlockList({
    blocks: mediaBlock.innerBlocks
  }), ...attrs, children: generateBlockList({
    blocks: bodyBlock.innerBlocks
  }) }, index);
};
BlockMediaObject.propTypes = {
  attrs: PropTypes.shape({
    reverse: PropTypes.bool
  }),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  BlockMediaObject as default
};
